var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.707 15.2928L54.707 8.29279C54.5195 8.10532 54.2652 8 54 8C53.7349 8 53.4806 8.10532 53.293 8.29279L23 38.5858L10.707 26.2928C10.5195 26.1053 10.2652 26 10 26C9.73487 26 9.48056 26.1053 9.29303 26.2928L2.29303 33.2928C2.10556 33.4803 2.00024 33.7346 2.00024 33.9998C2.00024 34.2649 2.10556 34.5193 2.29303 34.7068L22.293 54.7068C22.4806 54.8943 22.7349 54.9996 23 54.9996C23.2652 54.9996 23.5195 54.8943 23.707 54.7068L61.707 16.7068C61.8945 16.5193 61.9998 16.265 61.9998 15.9998C61.9998 15.7346 61.8945 15.4803 61.707 15.2928Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheck);
export default __webpack_public_path__ + "static/media/icon_check.b8c7d8983cf025f5a057f5a047debd0e.svg";
export { ForwardRef as ReactComponent };